import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { from, Observable } from 'rxjs';

@Component({
  selector: 'app-live-air',
  templateUrl: './live-air.component.html',
  styleUrls: ['./live-air.component.css']
})
export class LiveAirComponent implements OnInit {

  liveAirJson = 'https://data.epa.gov.tw/api/v1/aqx_p_432?format=json&limit=100&api_key=0d4104ac-48e3-4e10-a742-1a30d3f4a350';
  liveAir$: any;
  liveAirs: any;
  liveAir78: any;

  constructor(private httpService: HttpClient) { }

  ngOnInit(): void {
    this.liveAir$ = this.httpService.get(this.liveAirJson);
    this.liveAir$.subscribe(data => {
        this.liveAirs = data.records ;
        //console.log(this.liveAirs);
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
    );

  }

}
